import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { selectRedirect } from '@selectors'
import { CLEAR_REDIRECT } from '@redux/actions/types'

import { Redirect, useLocation } from 'react-router-dom'

const AppRedirect = () => {
  const dispatch = useDispatch()

  const redirect = useSelector(selectRedirect)

  const { pathname } = useLocation()
  
  const pathsMatch = pathname === redirect

  useEffect(() => {
    if (pathsMatch) {
      dispatch({
        type: CLEAR_REDIRECT
      })
    }
  }, [dispatch, pathsMatch])

  return !pathsMatch && redirect ? <Redirect to={redirect} /> : null
}

export default AppRedirect
